import { Box, Typography } from "@mui/material";
import { DataGrid, GridSortModel } from "@mui/x-data-grid";
import { Property } from "@stratify/shared";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectFilteredProperties,
  selectPropertiesError,
  selectPropertiesLoading,
} from "../store/propertiesSelectors";
import { setPropertiesFilters } from "../store/propertiesSlice";
import { PropertyListField } from "./types";
import { usePropertyListColumns } from "./usePropertyListColumns";

export const PropertyList: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const properties = useSelector(selectFilteredProperties);
  const loading = useSelector(selectPropertiesLoading);
  const error = useSelector(selectPropertiesError);

  const handleSortModelChange = useCallback(
    (model: GridSortModel) => {
      if (model.length > 0) {
        const { field, sort } = model[0];
        dispatch(
          setPropertiesFilters({
            sortBy: field as PropertyListField,
            sortOrder: sort === "asc" ? "asc" : "desc",
          })
        );
      } else {
        dispatch(
          setPropertiesFilters({
            sortBy: "createdAt",
            sortOrder: "desc",
          })
        );
      }
    },
    [dispatch]
  );

  const columns = usePropertyListColumns();

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}
      <DataGrid<Property>
        loading={loading}
        rows={properties}
        columns={columns}
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
        disableRowSelectionOnClick
        sortingMode="server"
        onSortModelChange={handleSortModelChange}
        onRowClick={(params) => navigate(`/properties/${params.row.id}`)}
        sx={{ cursor: "pointer" }}
      />
    </Box>
  );
};
